import { axios } from "../../lib/axios";

export const DeleteReview = (reviewId: string) => {
    return axios.delete(`/review/${reviewId}`)
        .then(response => response.data);
};